import { Banner } from "@jsq/ds/core";
import React from "react";
import { type UnauthenticatedArenaObjectType } from "../../../types";
import { SetupCard } from "../components/SetupCard";
import { type BaseSetupVariantProps, type VerifyRedirectEmailState } from "../types";

/**
 * A component for setting up 2FA with a email (uses the users associated email on the backend).
 * Forwards the decision to use email to the next component via the location state.
 */
export const EmailSetupVariant = ({
  onSwitch2FAMethodButtonClick,
  activationRedirectWithState,
  arena,
  isSplitScreen,
}: BaseSetupVariantProps<VerifyRedirectEmailState> & {
  arena?: UnauthenticatedArenaObjectType;
}) => {
  const handleSubmit = () => {
    activationRedirectWithState({
      state: { useAssociatedLoginEmail: true },
    });
  };

  return (
    <SetupCard
      onSwitch2FAMethodButtonClick={onSwitch2FAMethodButtonClick}
      methodTitle="Use email to authenticate"
      methodSubtitle="You will be sent a 6-digit code to your sign&nbsp;in email."
      submitButtonText="Acknowledge and continue with email"
      switch2FAMethodButtonText="Try another method to authenticate"
      onSubmit={handleSubmit}
      // @ts-expect-error code written before better codegen types
      submitButtonBackgroundColor={arena?.signInButtonBackgroundColor}
      // @ts-expect-error code written before better codegen types
      submitButtonTextColor={arena?.signInButtonTextColor}
      isSplitScreen={isSplitScreen}
    >
      <Banner
        title="This is the least secure authentication method."
        isDescriptionJsx
        description={
          <p className="text-md secondary">
            Only use this method if it&apos;s the last resort.
          </p>
        }
        variant="warning"
      />
    </SetupCard>
  );
};
